import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import { MeshPhysicalMaterial, MeshStandardMaterial } from "three";
import { PaneelGLTFResult } from "./PaneelType";
import {
  defaultDoorHeight,
  defaultDoorWidth,
} from "shared/utils/doorSceneConstants";

export const DeWaalLayout = ({
  chosenMaterial,
  nodes,
  doorIndex,
}: {
  chosenMaterial: MeshPhysicalMaterial | MeshStandardMaterial;
  nodes: PaneelGLTFResult["nodes"];
  doorIndex: number;
}) => {
  const { getConfigurationWidth, getConfigurationHeight, selectedDoor } =
    useConfigurationOptionsContext();

  const scaleDoorY = getConfigurationHeight(0) / defaultDoorHeight;
  const scaleDoorX = getConfigurationWidth(doorIndex) / defaultDoorWidth;

  const positionY =
    selectedDoor?.code === "dubbeleschuifdeur2paneel" ? -0.018 : -0.01;
  return (
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.beam_dewaal.geometry}
      material={chosenMaterial}
      scale-y={scaleDoorY}
      scale-x={scaleDoorX}
      position-y={positionY}
    />
  );
};
